module.exports = __webpack_public_path__ + "media/买新基.1c30d63.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/买新基.mp4
// module id = cSSr
// module chunks = 3